<template>
  <div class="w-full min-h-screen bg-white font-poppins">
    <ToastAlert
      :is-active="toastAlert"
      :type="typeMsg"
      :message="msg"
      :title="tittle"
    />

    <div v-show="!showModal && !showAddModal">
      <!-- Contenido Principal -->
      <div v-if="!loader_profile" class="w-full px-4 md:px-6 lg:px-8 py-6">
        <!-- Título -->
        <div class="mb-6 flex flex-col md:flex-row md:justify-between md:items-center gap-4">
          <h1 class="text-xl font-medium text-black">Historial de pagos</h1>
          
          <button
            @click="openAddModal"
            class="px-4 py-2 bg-[#FF4265] text-white rounded-lg hover:bg-[#e63859] transition-colors flex items-center gap-2 w-full md:w-auto justify-center md:justify-start"
          >
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
            </svg>
            Agregar Suscripción
          </button>
        </div>

        <!-- VISTA DESKTOP - Tabla tradicional -->
        <div class="hidden md:block w-full overflow-x-auto bg-white rounded-lg shadow-sm border border-gray-200">
          <table class="w-full min-w-[640px]">
            <!-- Header -->
            <thead>
              <tr class="bg-gray-50">
                <th class="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-tight">
                  ID de la factura
                </th>
                <th class="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-tight">
                  Plan
                </th>
                <th class="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-tight">
                  Fecha
                </th>
                <th class="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-tight">
                  Precio
                </th>
                <th class="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-tight">
                  Estatus
                </th>
                <th class="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-tight">
                  Acciones
                </th>
              </tr>
            </thead>

            <!-- Body -->
            <tbody class="divide-y divide-gray-200">
              <tr 
                v-for="(payment, index) in paginatedPayments" 
                :key="payment.id"
                class="hover:bg-gray-50 transition-colors"
              >
                <!-- ID Factura -->
                <td class="px-4 py-4">
                  <span class="text-sm font-semibold text-gray-900">{{ payment.invoiceId }}</span>
                </td>
                
                <!-- Nombre -->
                <td class="px-4 py-4">
                  <span class="text-sm text-gray-500">{{ payment.plan_name }}</span>
                </td>

                <!-- Fecha -->
                <td class="px-4 py-4">
                  <span class="text-sm text-gray-500">{{formatDate(payment.date)}}</span>
                </td>

                <!-- Precio -->
                <td class="px-4 py-4">
                  <span class="text-sm font-semibold text-gray-900">{{ formatPrice(payment.amount) }}</span>
                </td>

                <!-- Estatus -->
                <td class="px-4 py-4">
                  <span 
                    :class="getStatusClass(payment.status)"
                    class="inline-flex px-2.5 py-0.5 rounded-md text-xs font-medium"
                  >
                    {{ getStatusText(payment.status) }}
                  </span>
                </td>

                <!-- Acciones -->
                <td class="px-4 py-4">
                  <button
                    @click.stop="toggleMenu(getCurrentIndex(index), $event)"
                    class="p-1 hover:bg-gray-100 rounded transition-colors"
                    aria-label="Acciones"
                  >
                    <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none">
                      <circle cx="5" cy="12" r="2" fill="#EF4444" />
                      <circle cx="12" cy="12" r="2" fill="#EF4444" />
                      <circle cx="19" cy="12" r="2" fill="#EF4444" />
                    </svg>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Estado vacío Desktop -->
          <div v-if="payments.length === 0" class="py-12 text-center">
            <p class="text-gray-500 text-sm">No hay pagos registrados</p>
          </div>
        </div>

        <!-- VISTA MOBILE - Tarjetas en columna única -->
        <div class="md:hidden space-y-2">
          <div
            v-for="(payment) in paginatedPayments"
            :key="payment.id"
            class="bg-white rounded-lg shadow-sm border border-gray-200 p-3 hover:shadow-md transition-shadow"
          >
            <!-- Contenedor principal clickeable -->
            <div
              @click="openModalForm(payment)"
              class="cursor-pointer flex items-center justify-between gap-3"
            >
              <div class="flex-1 min-w-0">
                <p class="text-sm font-semibold text-gray-900 truncate">{{ payment.invoiceId }}</p>
                <p class="text-sm font-semibold text-gray-900 truncate">{{ payment.plan_name }}</p>
                <p class="text-xs text-gray-500">{{ formatDate(payment.date) }}</p>
                <div class="flex items-center gap-2 mt-1">
                  <span class="text-sm font-semibold text-gray-900">{{ formatPrice(payment.amount) }}</span>
                  <span 
                    :class="getStatusClass(payment.status)"
                    class="inline-flex px-2 py-0.5 rounded text-xs font-medium"
                  >
                    {{ getStatusText(payment.status) }}
                  </span>
                </div>
              </div>
              <!-- Solo mostrar botón de descarga si NO es transferencia -->
              <button
                v-if="!payment.isTransfer"
                @click.stop="downloadInvoice(payment)"
                class="p-2 hover:bg-gray-100 rounded-lg transition-colors flex-shrink-0"
                :title="`Descargar ${payment.invoiceId}`"
              >
                <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
              </button>
              <button
                v-if="payment.status === 'active'"
                @click.stop="desactivateSuscription(payment.id)"
                class="p-2 hover:bg-gray-100 rounded-lg transition-colors flex-shrink-0"
                :title="`Desactivar suscripción ${payment.id}`"
              >
                <svg class="w-5 h-5 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M9 7h6m-7 0a1 1 0 011-1h6a1 1 0 011 1m-9 0h10" />
                </svg>
              </button>
            </div>
          </div>

          <!-- Estado vacío Mobile -->
          <div v-if="payments.length === 0" class="py-12 text-center">
            <p class="text-gray-500 text-sm">No hay pagos registrados</p>
          </div>
        </div>

        <!-- Paginador -->
        <div v-if="payments.length > 0" class="flex justify-between items-center w-full mt-4">
          <div class="w-[278px] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal hidden md:block">
            Mostrando {{ currentPage }} de {{ totalPages }}
          </div>
          
          <!-- Controles de paginación -->
          <div style="display: flex; justify-content: flex-end; align-items: center; padding: 8px 12px;">
            <button 
              @click="changePage(currentPage - 1)" 
              :disabled="currentPage === 1"
              :style="{
                padding: '8px 12px', 
                border: '1px solid #FFD8DF', 
                background: '#FFF', 
                color: '#FF4265', 
                opacity: currentPage === 1 ? '0.5' : '1',
                cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
              }"
            >
              &lt;
            </button>
            
            <!-- Números de página -->
            <div style="display: flex; gap: 0; align-items: center;">
              <button
                v-for="pageNumber in totalPages" 
                :key="pageNumber" 
                @click="changePage(pageNumber)" 
                :style="{
                  padding: '8px 12px',
                  border: '1px solid #FFD8DF',
                  background: pageNumber === currentPage ? '#FF4265' : '#FFF',
                  color: pageNumber === currentPage ? '#FFF' : '#FF4265',
                  fontWeight: pageNumber === currentPage ? 'bold' : 'normal',
                  cursor: 'pointer'
                }"
              >
                {{ pageNumber }}
              </button>
            </div>
            
            <button 
              @click="changePage(currentPage + 1)" 
              :disabled="currentPage === totalPages"
              :style="{
                padding: '8px 12px',
                border: '1px solid #FFD8DF',
                background: '#FFF',
                color: '#FF4265',
                opacity: currentPage >= totalPages ? '0.5' : '1',
                cursor: currentPage >= totalPages ? 'not-allowed' : 'pointer'
              }"
            >
              &gt;
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Menú Dropdown FLOTANTE - Completamente independiente de la tabla -->
    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <div
        v-if="activeMenu !== null && dropdownStyle.top !== undefined"
        :style="dropdownStyle"
        class="fixed w-36 bg-white rounded-lg shadow-lg border border-gray-200 z-[9999]"
      >
        <div class="py-1">
          <button
            @click="openModalForm(payments[activeMenu])"
            class="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2 transition-colors"
          >
            <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
            Ver
          </button>
          <!-- Solo mostrar botón de descarga si NO es transferencia -->
          <button
            v-if="activeMenu !== null && !payments[activeMenu]?.isTransfer"
            @click.stop="downloadInvoice(payments[activeMenu])"
            class="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2 transition-colors"
          >
            <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
            Descargar
          </button>
          <button
            v-if="payments[activeMenu].status === 'active'"
            @click.stop="desactivateSuscription(payments[activeMenu].id)"
            class="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2 transition-colors"
          >
            <svg class="w-5 h-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M9 7h6m-7 0a1 1 0 011-1h6a1 1 0 011 1m-9 0h10" />
            </svg>
            Desactivar
          </button>
        </div>
      </div>
    </transition>

    <div v-if="showModal" class="fade-in">
      <ModalFormViewPaymentComponent
        :payment="selectedPayment"
        @close="closeModalForm"
      />
    </div>

    <!-- Modal Agregar Suscripción -->
    <ModalAddSubscription
      :is-visible="showAddModal"
      :advisor-id="advisorId"
      :plans="plans"
      @close="closeAddModal"
      @submit="handleAddSubscription"
    />
  </div>
</template>

<script setup>
  import { ref, onMounted, onUnmounted, computed } from 'vue'
  import axios from "axios";
  import ModalFormViewPaymentComponent from "@/components/advisor/ViewPaymentComponent.vue";
  import ModalAddSubscription from "@/components/advisor/modal/Subscription_modal.vue";
  import { useRouter, useRoute } from "vue-router";
  import { useStore } from "vuex";
  
  const route = useRoute();
  const store = useStore();
  let session = computed(() => store.getters.getUserSession);
  let router = useRouter();
  let showModal = ref(false);
  let showAddModal = ref(false);
  const selectedPayment = ref(null);
  const advisorId = computed(() => route.params.id);

  // State
  let loader_profile = ref(false);
  const toastAlert = ref(false)
  const typeMsg = ref('')
  const msg = ref('')
  const tittle = ref('')
  const activeMenu = ref(null)
  const dropdownStyle = ref({})
  const activeButtonElement = ref(null)

  // Datos de ejemplo - Reemplaza con tus datos reales
  const payments = ref([])
  const plans = ref([])
  const currentPage = ref(1)
  const itemsPerPage = ref(10)

  function openModalForm(payment) {
    selectedPayment.value = payment;
    showModal.value = true;
    closeMenu();
  }

  function closeModalForm() {
    showModal.value = false;
    selectedPayment.value = null;
  }

  function openAddModal() {
    showAddModal.value = true;
  }

  function closeAddModal() {
    showAddModal.value = false;
  }

  async function handleAddSubscription(data) {
    try {
      const options = {
        headers: {
          Authorization: `Bearer ${session.value.token_api}`,
        },
      };

      const payload = {
        user_id: advisorId.value,
        plan_id: data.plan_id,
        amount: data.amount,
        payment_type: data.payment_type,
        billing_cycle: data.billing_cycle,
        starts_at: data.starts_at,
        ends_at: data.ends_at,
        currency: 'MXN',
        status: 'active'
      };

      const response = await axios.post(
        `${process.env.VUE_APP_API_BASE_URL}/broker/createSubscription`,
        payload,
        options
      );

      if (response.status === 200) {
        toastAlert.value = true;
        typeMsg.value = 'success';
        msg.value = 'Suscripción agregada correctamente';
        tittle.value = 'Éxito';
        setTimeout(() => { toastAlert.value = false; }, 3000);
        
        closeAddModal();
        await getPaymentHistory();
      }
    } catch (error) {
      const response = error.response;
      if (response && response.status === 401) {
        store.dispatch("clearUserSession");
        router.push({ name: 'login' });
      } else {
        toastAlert.value = true;
        typeMsg.value = 'error';
        msg.value = response?.data?.message || 'Error al agregar suscripción';
        tittle.value = 'Error';
        setTimeout(() => { toastAlert.value = false; }, 3000);
      }
    }
  }

  function formatPrice(value) {
    if (!value) return "0.00";

    return new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN"
    }).format(value);
  }

  async function fetchPlanes() {
    try {
      let options = {
        headers: {
          'Authorization': `Bearer ${session.value.token_api}`
        }
      };
      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/planes-all`, options
      );

      if (response.status === 401) {
        store.dispatch('clearUserSession');
      }

      if (response.status === 200 && response.data?.plans) {
        plans.value = response.data.plans;
      }
    } catch (error) {
      console.error("Error al obtener los planes:", error);
    }
  }

  async function getPaymentHistory() {
    loader_profile.value = true;
    try {
      const options = {
        headers: {
          Authorization: `Bearer ${session.value.token_api}`,
        },
      };

      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/broker/historySuscription/${advisorId.value}`,
        options
      );

      console.log("🔹 Respuesta completa del backend:", response.data);

      if (response.status === 200) {
        const data = response.data.original?.records || [];
        
        // Filtrar registros que tengan plan_id = 9
        const filteredData = data.filter(p => p.plan_id !== 9);
        // Contador para transferencias
        let transferCount = 0;
        
        payments.value = filteredData.map((p) => {
          // Si no tiene stripe_payment_id, es una transferencia
          const isTransfer = !p.stripe_payment_id;
          let invoiceId;
          
          if (isTransfer) {
            transferCount++;
            invoiceId = `TRANSFER_${transferCount}`;
          } else {
            invoiceId = `#${p.stripe_payment_id.substring(0, 6).toUpperCase()}`;
          }
          
          return {
            id: p.id,
            name_user: p.user.full_name,
            plan_name: p.plan?.name || 'Sin plan',
            email_user: p.user.email,
            stripe_subscription_id: p.stripe_subscription_id,
            invoiceId: invoiceId,
            invoiceIdAll: p.stripe_payment_id,
            isTransfer: isTransfer,
            date: new Date(p.starts_at).toLocaleDateString("es-MX", {
              year: "numeric",
              month: "long",
              day: "numeric",
            }),
            amount: p.amount,
            currency: p.currency || "MXN",
            status: p.status,
            description: `Pago del plan ${p.plan_id ?? ""}`,
            receipt_url: p.receipt_url,
            card: {
              brand: p.card_brand,
              last4: p.card_last4,
            },
            iva: p.iva ?? (p.amount * 0.16).toFixed(2),
            subtotal: p.subtotal ?? (p.amount - ((p.amount * 0.16).toFixed(2))),
            exp: p.ends_at,
            invoice: {
              hosted_invoice_url: p.invoice_url,
            },
          };
        });

        console.log("✅ Suscripciones procesadas:", payments.value);
        loader_profile.value = false;
      }
    } catch (error) {
      const response = error.response;
      if (response && response.status === 401) {
        store.dispatch("clearUserSession");
        router.push({ name: 'login' });
      } else {
        console.error("❌ Error al obtener pagos:", response?.data || error);
      }
      loader_profile.value = false;
    }
  }

  async function desactivateSuscription(subscriptionId) {
    try {
      closeMenu();
      let options = {
        headers: {
          Authorization: `Bearer ${session.value.token_api}`,
        },
        responseType: 'blob'
      };

      const response = await axios.post(
        `${process.env.VUE_APP_API_BASE_URL}/broker/desactivateSuscription/${subscriptionId}`,
        {},
        options
      );
      
      console.log(response)

      if (response.status == 200) {
        loader_profile.value = false;
        toastAlert.value = true;
        typeMsg.value = 'success';
        msg.value = 'Se descargo correctamete';
        tittle.value = 'Éxito';
        setTimeout(() => { toastAlert.value = false; }, 3000);
        await getPaymentHistory();
      }
    } catch (error) {
      let response = error.response;
      if(response && response.status == 401){
        store.dispatch("clearUserSession"); 
        router.push({ name: 'login' });
      } else {
        toastAlert.value = true;
        typeMsg.value = 'error';
        msg.value = 'Error al desactivar';
        tittle.value = 'Error';
        setTimeout(() => { toastAlert.value = false; }, 3000);
      }
      console.error("Error al desactivar:", error);
    }
  }

  async function downloadInvoice(payment) {
    loader_profile.value = true;
    try {
      closeMenu();

      // Validar que exista la factura
      if (!payment.stripe_subscription_id) {
        console.warn('No hay hosted_invoice_url, intentando método alternativo...');
        // Ejecuta el método alternativo
        await downloadInvoicetwo(payment);
        return;
      }

      const pdfUrl = payment.invoice.hosted_invoice_url;

      // Abrir la factura en nueva pestaña
      window.open(pdfUrl, '_blank');

      toastAlert.value = true;
      typeMsg.value = 'success';
      msg.value = 'Recibo abierto exitosamente';
      tittle.value = 'Éxito';
      setTimeout(() => { toastAlert.value = false; }, 3000);
      loader_profile.value = false;

    } catch (error) {
      toastAlert.value = true;
      typeMsg.value = 'error';
      msg.value = 'Error al abrir el recibo';
      tittle.value = 'Error';
      setTimeout(() => { toastAlert.value = false; }, 3000);
      console.error("Error downloading invoice:", error);
    }
  }
  
  async function downloadInvoicetwo(payment) {
    try {
      closeMenu();
      let options = {
        headers: {
          Authorization: `Bearer ${session.value.token_api}`,
        },
        responseType: 'blob'
      };


      
      const payload = {
        url: payment.invoice.hosted_invoice_url,
        name: `recibo_${payment.id}.pdf`
      };

      console.log(payload);
      const response = await axios.post(
        `${process.env.VUE_APP_API_BASE_URL}/broker/download-receipt`,
        payload,
        options
      );
      
      console.log(response)

      if (response.status == 200) {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `recibo_${payment.invoiceId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        loader_profile.value = false;
        toastAlert.value = true;
        typeMsg.value = 'success';
        msg.value = 'Recibo descargado exitosamente';
        tittle.value = 'Éxito';
        setTimeout(() => { toastAlert.value = false; }, 3000);
      }
    } catch (error) {
      let response = error.response;
      if(response && response.status == 401){
        store.dispatch("clearUserSession"); 
        router.push({ name: 'login' });
      } else {
        toastAlert.value = true;
        typeMsg.value = 'error';
        msg.value = 'Error al descargar el recibo';
        tittle.value = 'Error';
        setTimeout(() => { toastAlert.value = false; }, 3000);
      }
      console.error("Error downloading invoice:", error);
    }
  }

  // Computed para paginación
  const totalPages = computed(() => {
    return Math.ceil(payments.value.length / itemsPerPage.value)
  })

  const paginatedPayments = computed(() => {
    const start = (currentPage.value - 1) * itemsPerPage.value
    const end = start + itemsPerPage.value
    return payments.value.slice(start, end)
  })

  // Función para obtener el índice real del array completo
  const getCurrentIndex = (paginatedIndex) => {
    return (currentPage.value - 1) * itemsPerPage.value + paginatedIndex
  }

  // Función para cambiar de página
  const changePage = (page) => {
    if (page >= 1 && page <= totalPages.value) {
      currentPage.value = page
      closeMenu() // Cerrar menú al cambiar de página
    }
  }

  const getStatusClass = (status) => {
    return {
      'bg-yellow-100 text-yellow-800': status === 'canceled',
      'bg-green-100 text-green-800': status === 'active',
      'bg-red-100 text-red-800': status === 'expired' || status === 'inactive',
    }
  }

  const getStatusText = (status) => {
    const statusTexts = {
      canceled: 'Cancelado',
      active: 'Activo',
      expired: 'Expirado',
      inactive: 'Expirado'
    }
    return statusTexts[status] || status
  }

  const toggleMenu = (index, event) => {
    if (activeMenu.value === index) {
      closeMenu()
      return
    }

    activeMenu.value = index
    activeButtonElement.value = event.currentTarget
    updateDropdownPosition(event.currentTarget)
  }

  const updateDropdownPosition = (button) => {
    if (!button) return
    
    const rect = button.getBoundingClientRect()
    
    const dropdownHeight = 100
    const viewportHeight = window.innerHeight
    
    const spaceBelow = viewportHeight - rect.bottom
    const shouldOpenUpward = spaceBelow < dropdownHeight
    
    if (shouldOpenUpward) {
      dropdownStyle.value = {
        top: `${rect.top - dropdownHeight + 8}px`,
        left: `${rect.right + 8}px`
      }
    } else {
      dropdownStyle.value = {
        top: `${rect.top}px`,
        left: `${rect.right + 8}px`
      }
    }
  }

  const closeMenu = () => {
    activeMenu.value = null
    activeButtonElement.value = null
    dropdownStyle.value = {}
  }

  const handleScroll = () => {
    if (activeMenu.value !== null && activeButtonElement.value) {
      updateDropdownPosition(activeButtonElement.value)
    }
  }

  function formatDate(dateString) {
    if (!dateString) return '';
    const partes = dateString.split(' de ');
    if (partes.length === 3) {
      const [dia, mes, anio] = partes;
      return `${mes.charAt(0).toUpperCase() + mes.slice(1)} ${dia}, ${anio}`;
    }
    return dateString;
  }

  const handleClickOutside = (event) => {
    if (activeMenu.value !== null) {
      const dropdown = document.querySelector('.fixed.w-36')
      const buttons = document.querySelectorAll('button[aria-label="Acciones"]')
      
      let clickedInside = false
      
      if (dropdown && dropdown.contains(event.target)) {
        clickedInside = true
      }
      
      buttons.forEach(button => {
        if (button.contains(event.target)) {
          clickedInside = true
        }
      })
      
      if (!clickedInside) {
        closeMenu()
      }
    }
  }

  // Lifecycle
  onMounted(() => {
    document.addEventListener('click', handleClickOutside)
    window.addEventListener('scroll', handleScroll, true)
    getPaymentHistory()
    fetchPlanes()
  })

  onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside)
    window.removeEventListener('scroll', handleScroll, true)
  })
</script>

<style scoped>
.font-poppins {
  font-family: 'Poppins', sans-serif;
}

@media (max-width: 640px) {
  .overflow-x-auto {
    -webkit-overflow-scrolling: touch;
  }
}

::v-deep .custom-label label {
  @apply text-white;
}

::v-deep .custom-label label.block.mb-2.text-sm.font-medium {
  @apply text-white;
}

body {
  background-color: #ffffff !important;
}
</style>